﻿import * as eventTypes from '../../../map/utils/eventTypes';
import * as layerTypes from '../../../map/utils/layerTypes';
import * as geomTypes from '../../../map/utils/geomTypes';
import Draw, { createBox, createRegularPolygon } from 'ol/interaction/Draw';
import Collection from 'ol/Collection';
import {
    Circle as CircleStyle,
    Fill,
    RegularShape,
    Stroke,
    Style,
    Text,
} from 'ol/style.js';
import { primaryAction } from 'ol/events/condition';
import Snap from 'ol/interaction/Snap';
import { LineString, Point, Polygon } from 'ol/geom.js';
import { fromExtent, fromCircle } from 'ol/geom/Polygon';
import { getArea, getLength } from 'ol/sphere.js';
import DwgDxfExportControl from './export/DwgDxfExportControl';
import GeoJsonExportControl from './export/GeoJsonExportControl';
import ShapeExportControl from './export/ShapeExportControl';
import WKT from 'ol/format/WKT';

export default class ExportToolbarControl {
    constructor(action, resourcesHandler, layerSettingsHandler, exportContainer, rootURL, classId, mapControl, snapOpts, menuContainer, modalWrapper) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.exportContainer = exportContainer;
        this.menuContainer = menuContainer;
        this.modalWrapper = modalWrapper;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.map = mapControl.map;
        this.currentInteraction = null;
        this.snaps = [];
        this.snapOpts = snapOpts;
        this.isSnapActive = false;
        this.layerAdded = false;
        this.exportPanel = null;
        this.currentSelection = 'view';

        this.toolbarActions = [
            { action: "export-view", active: true, icon: "fal fa-expand", title: this.resourcesHandler.get("SelectByView"), handler: this._getSelectByViewHandler(), options: null },
            { action: "export-circle", icon: "fal fa-circle", title: this.resourcesHandler.get("SelectByCircle"), handler: this._getSelectByCircleHandler(), options: null },
            { action: "export-line", icon: "ni ni-graph", title: this.resourcesHandler.get("SelectByLine"), handler: this._getSelectByLineHandler(), options: null },
            { action: "export-rectangle", icon: "fal fa-square", title: this.resourcesHandler.get("SelectByRectangle"), handler: this._getSelectByRectangleHandler(), options: null },
            { action: "export-polygon", icon: "fal fa-draw-polygon", title: this.resourcesHandler.get("SelectByPolygon"), handler: this._getSelectByPolygonHandler(), options: null },
            { action: "export-all", icon: "fal fa-server", title: this.resourcesHandler.get("ExportAllFeatures"), handler: this._getSelectAllHandler(), options: null }
        ];
        this.mapMoveEndHandler = this._getMapMoveEndHandler();
        $event.register(eventTypes.MAP_MOVE_END, this.mapMoveEndHandler, this, this.mapControl.classId);
    }

    init() {
        if (this._isMobileDevice()) return;

        $event.register(eventTypes.USER_INTERACTION_STARTED, this._getUserInteractionStartedHandler(), this, this.classId);

        if ($('.map-serach-config').length > 0) {
            $('.map-serach-config').addClass('map-search-joined');
        }

        this.menuContainer.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());

        this._initDrawStyle();

        $(this.exportContainer).append('<div class="map-toolbar toolbar-export shadow-4" style="display:none; left: 3.7rem;  right: unset; width: fit-content;"></div>');
        $(this.exportContainer).find(".toolbar-export").append('<ul class="map-toolbar-export-list joined"></ul>');

        $(this.exportContainer).find(".toolbar-export").append(`<ul class="map-toolbar-export-options">
            <li class="toolbar-export-options-wrapper">
                <div class="form-row" style="width: 11.5rem;">
                    <div class="form-group col-10">
                        <label class="form-label">Format Export</label>
                        <input class="form-control" type="text" id="export-format-id"></input>
                    </div>
                    <div class="form-group col-2" style="height: 2rem; margin-top: 1.5rem;">
                        <button class="btn btn-primary" id="start-export">OK</button>
                    </div>
                </div>
            </li>
        </ul>`);

        for (var i = 0; i < this.toolbarActions.length; i++) {
            $(this.exportContainer).find(".map-toolbar-export-list").append('<li' + (this.toolbarActions[i].display != null ? (' style="display:' + this.toolbarActions[i].display + ';"') : '') + ' class="map-toolbar-item header-icon ' + this.toolbarActions[i].action + ' ' + (this.toolbarActions[i].active ? 'active' : '') + '" title="' + this.resourcesHandler.get(this.toolbarActions[i].title)
                + '"><i class="' + this.toolbarActions[i].icon + '" style="font-size: 1rem !important;"></i></li>');
            if (this.toolbarActions[i].options == null && this.toolbarActions[i].handler != null) {
                $(this.exportContainer).find("." + this.toolbarActions[i].action).click(this.toolbarActions[i].handler);
            }
            else if (this.toolbarActions[i].options != null && this.toolbarActions[i].options.length > 0) {
                $(this.exportContainer).find("." + this.toolbarActions[i].action).attr("data-toggle", "dropdown");
                $(this.exportContainer).find("." + this.toolbarActions[i].action).append('<div class="dropdown-menu"></div>');
                for (var j = 0; j < this.toolbarActions[i].options.length; j++) {
                    $(this.exportContainer).find("." + this.toolbarActions[i].action).find(".dropdown-menu").append(
                        '<a class="dropdown-item" data-action="' + this.toolbarActions[i].options[j].action + '" href="javascript:void(0)">' + this.toolbarActions[i].options[j].title + '</a>'
                    );
                    $(this.exportContainer).find("." + this.toolbarActions[i].action).find(".dropdown-item[data-action='" + this.toolbarActions[i].options[j].action + "']").click(this.toolbarActions[i].options[j].handler);
                }
            }
        }

        $('#export-format-id').kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: [{
                id: 'DWG',
                name: this.resourcesHandler.get('DWG')
            }, {
                id: 'DXF',
                name: this.resourcesHandler.get('DXF')
            }, {
                id: 'GeoJSON',
                name: this.resourcesHandler.get('GeoJSON')
            }, {
                id: 'SHP',
                name: this.resourcesHandler.get('Shape')
            }]
        });

        $('#export-format-id').data('kendoComboBox').value('DWG');

        $('#start-export').on('click', () => {
            this._showExport();
        });
    }

    _getMapMoveEndHandler() {
        return () => {
            if (this.isSnapActive) {
                this._adjustSnap(this.snapOpts);
            }
        };
    }

    _adjustSnap(opts) {
        if (this.snaps.length > 0) {
            this.snaps.forEach(snap => {
                this.map.removeInteraction(snap);
            });
            this.snaps = [];
        }

        this._addSnapInteraction(opts);
    }

    _addSnapInteraction(opts) {
        this._clearSnap();

        let snap = new Snap({
            features: new Collection(this.mapControl.selectionHandler.getVisibleFeaturesInExtent(this.mapControl.getViewExtent())),
            pixelTolerance: opts.pixelTolerance,
            edge: opts.edge,
            vertex: opts.vertex,
            intersection: opts.intersection
        });
        this.snaps.push(snap);
        this.map.addInteraction(snap);

        this.isSnapActive = true;
    }

    _clearSnap() {
        const snapsToRemove = [];
        this.map.getInteractions().forEach((interaction) => {
            if (interaction instanceof Snap) {
                snapsToRemove.push(interaction);
            }
        });

        snapsToRemove.forEach((snapInteraction) => {
            this.map.removeInteraction(snapInteraction);
        });
    }

    _showExport() {
        let exportFormat = $('#export-format-id').data('kendoComboBox').value();

        let geometry;

        if (this.currentSelection == 'view') {
            geometry = fromExtent(this.mapControl.getViewExtent());
        } else if (this.currentSelection == 'circle') {
            let drawnFeatures = this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource().getFeatures();

            if (drawnFeatures != null && drawnFeatures.length > 0) {
                geometry = fromCircle(drawnFeatures[0].getGeometry(), 42);
            }
        } else if (this.currentSelection != 'all') {
            let drawnFeatures = this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource().getFeatures();

            if (drawnFeatures != null && drawnFeatures.length > 0) {
                geometry = drawnFeatures[0].getGeometry();
            }
        }

        let wkt = new WKT().writeGeometry(geometry);

        switch (exportFormat) {
            case 'DXF': this.exportPanel = new DwgDxfExportControl(this.mapControl, this.layerSettingsHandler, this.resourcesHandler, this.classId, exportFormat, wkt, this.modalWrapper, this.rootURL);
                break;
            case 'DWG': this.exportPanel = new DwgDxfExportControl(this.mapControl, this.layerSettingsHandler, this.resourcesHandler, this.classId, exportFormat, wkt, this.modalWrapper, this.rootURL);
                break;
            case 'GeoJSON': this.exportPanel = new GeoJsonExportControl(this.mapControl, this.layerSettingsHandler, this.resourcesHandler, this.classId, exportFormat, wkt, this.modalWrapper, this.rootURL);
                break;
            case 'SHP': this.exportPanel = new ShapeExportControl(this.mapControl, this.layerSettingsHandler, this.resourcesHandler, this.classId, exportFormat, wkt, this.modalWrapper, this.rootURL);
                break;
        }

        this._getSelectByViewHandler()();
    }

    _getUserInteractionStartedHandler() {
        var handler = (eventName, data, sender) => {
            this._removeInteraction();
            this._hideToolbar();
        };

        return handler;
    }

    _removeInteraction() {
        if (this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT).length > 0) {
            this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource().clear();
        }

        if (this.currentInteraction != null) {
            this.mapControl.map.removeInteraction(this.currentInteraction);
            this.currentInteraction = null;
        }

        if (this.snaps.length > 0) {
            this.snaps.forEach(snap => {
                this.mapControl.map.removeInteraction(snap);
            });
            this.snaps = [];
        }

        this.deleteEnabled = false;
    }

    _initDrawStyle() {
        this.drawMeasureStyle = new Style({
            fill: new Fill({
                color: 'rgba(255, 0, 0, 1)',
            }),
            stroke: new Stroke({
                color: 'rgba(51, 153, 204, 1)',
                width: 3,
            }),
            image: new RegularShape({
                radius: 8,
                radius2: 1,
                points: 4,
                angle: 0,
                stroke: new Stroke({
                    color: 'rgba(255, 0, 0, 1)',
                }),
                fill: new Fill({
                    color: 'rgba(255, 0, 0, 1)',
                }),
            }),
        });

        this.drawLabelStyle = new Style({
            text: new Text({
                font: 'bold 16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(0, 0, 0, 1)',
                }),
                backgroundFill: new Fill({
                    color: 'rgba(0, 0, 0, 0)',
                }),
                padding: [3, 3, 3, 3],
                textBaseline: 'bottom',
                offsetY: -10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                })
            })
        });
    }

    _drawStyleFunction(feature, drawType) {
        let styles = [];
        let geometry = feature.getGeometry();
        let type = geometry.getType();
        let point, label, line, circleLine, pointLabel;
        if (!drawType || drawType === type || type === 'Point') {
            let allStyle = this.drawMeasureStyle.clone();
            if (drawType == 'Circle' || drawType == 'Polygon') {
                allStyle.getFill().setColor('rgba(255, 255, 255, 0.4)');
            }

            if (type != 'Point') {
                styles.push(allStyle);
            }

            if (type === 'Polygon') {
                point = geometry.getInteriorPoint();
                label = this._formatArea(feature, geometry);
                if (geometry.getCoordinates()[0].length > 2) {
                    line = new LineString([geometry.getCoordinates()[0][geometry.getCoordinates()[0].length - 3], geometry.getCoordinates()[0][geometry.getCoordinates()[0].length - 2]]);
                }
            } else if (type === 'LineString') {
                point = new Point(geometry.getLastCoordinate());
                label = this._formatLength(feature, getLength(geometry));
                pointLabel = this._formatCoordinates(feature, point);
                line = geometry;
            } else if (drawType == 'Circle' && type != 'Point') {
                point = new Point(geometry.getCenter());
                label = this._formatCircleArea(feature, geometry);

                let secondPoint = geometry.getCenter();
                secondPoint[0] += geometry.getRadius();
                circleLine = new LineString([geometry.getCenter(), secondPoint]);
            } else if (drawType == 'Point' || (type == 'Point' && drawType != 'Point')) {
                point = new Point(geometry.getCoordinates());
                label = this._formatCoordinates(feature, geometry);
            }
        }

        let lastSegmentAngle;
        let perimeterLabel;
        let perimeter;
        let cursorPoint;

        if (line) {
            line.forEachSegment((a, b) => {
                let segment = new LineString([a, b]);
                let angle = this._formatAngle(feature, segment);
                lastSegmentAngle = this.drawLabelStyle.clone();
                cursorPoint = new Point(segment.getLastCoordinate());
                lastSegmentAngle.setGeometry(cursorPoint);
                lastSegmentAngle.getText().setText(angle);

                if (type == 'Polygon') {
                    lastSegmentAngle.getText().setOffsetY(27);
                } else {
                    lastSegmentAngle.getText().setOffsetY(40);
                }
            });
        }

        if (type == 'Polygon') {
            let points = feature.getGeometry().getCoordinates()[0];
            perimeter = 0;

            for (let i = 1; i < points.length; i++) {
                let segment = new LineString([points[i - 1], points[i]]);
                perimeter += getLength(segment);

                perimeterLabel = this.drawLabelStyle.clone();
                perimeterLabel.setGeometry(geometry.getInteriorPoint());
                perimeterLabel.getText().setText(this._formatLength(feature, perimeter));
                perimeterLabel.getText().setOffsetY(10);
            }
        }

        if (label) {
            let clone = this.drawLabelStyle.clone();
            clone.setGeometry(point);
            clone.getText().setText(label);

            if (pointLabel) {
                clone.getText().setOffsetY(27);
            }

            styles.push(clone);
        }

        if (pointLabel) {
            let clone = this.drawLabelStyle.clone();
            clone.setGeometry(point);
            clone.getText().setText(pointLabel);

            styles.push(clone);
        }

        if (lastSegmentAngle) {
            styles.push(lastSegmentAngle);
        }

        if (perimeterLabel) {
            styles.push(perimeterLabel);
        }

        return styles;
    }

    _formatCoordinates(feature, geometry) {
        let coordinates = geometry.getCoordinates();
        return Math.round(coordinates[0] * 1000) / 1000 + ' \n ' + Math.round(coordinates[1] * 1000) / 1000;
    }

    _formatCircleArea(feature, circle) {
        let radius = circle.getRadius();
        let area = Math.PI * Math.pow(radius, 2);

        return Math.round(area * 100) / 100 + ' m\xB2';
    }

    _getClearSelectionHandler() {
        return () => {
            $event.notify(eventTypes.CLEAR_MULTIPLE_SELECTION, {}, this, this.classId);
            $('.map-toolbar-item.clear-selection').hide();
        };
    }

    _formatLength(feature, length) {
        return Math.round(length * 100) / 100 + ' m';
    }

    _formatAngle(feature, geometry) {
        return Math.round(this._getRotation(geometry) * 1000) / 1000 + ' °';
    }

    _getRotation(geometry) {
        let coords = geometry.getCoordinates();

        let first = coords[0];
        let last = coords[1];
        let rotation = -Math.atan2((last[1] - first[1]), (last[0] - first[0]));
        rotation = rotation * (180 / Math.PI);

        if (rotation < 0) {
            rotation = 360 + rotation;
        }

        rotation += 90;

        if (rotation > 360) {
            rotation -= 360;
        }

        return rotation;
    }

    _formatArea(feature, polygon) {
        let area = getArea(polygon);
        return Math.round((area / 1000000) * 100) / 100 + ' km\xB2';
    }

    _getSelectByViewHandler() {
        return () => {
            $(this.exportContainer).find(".map-toolbar-item").removeClass('active');
            $(this.exportContainer).find(".export-view").addClass('active');

            this.mapControl.selectionHandler.isActive = true;
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this._selectByView();
        };
    }

    _selectByView() {
        this.currentSelection = 'view';
        this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource().clear();
        $('#start-export').removeAttr('disabled');
        this._removeInteraction();
    }

    _getSelectByCircleHandler() {
        return () => {
            $(this.exportContainer).find(".map-toolbar-item").removeClass('active');
            $(this.exportContainer).find(".export-circle").addClass('active');

            this.mapControl.selectionHandler.isActive = false;
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            $('#start-export').attr('disabled', 'true');
            this._selectByCircle();
        };
    }

    _selectByCircle() {
        this.currentSelection = 'circle';
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource(),
            type: 'Circle',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Circle');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource().clear();
            $('#start-export').removeAttr('disabled');
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        this._addSnapInteraction(this.snapOpts);
    }

    _getSelectByLineHandler() {
        return () => {
            $(this.exportContainer).find(".map-toolbar-item").removeClass('active');
            $(this.exportContainer).find(".export-line").addClass('active');

            this.mapControl.selectionHandler.isActive = false;
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            $('#start-export').attr('disabled', 'true');
            this._selectByLine();
        };
    }

    _selectByLine() {
        this.currentSelection = 'line';
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource(),
            type: 'LineString',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'LineString');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource().clear();
            $('#start-export').removeAttr('disabled');
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        this._addSnapInteraction(this.snapOpts);
    }

    _getSelectByRectangleHandler() {
        return () => {
            $(this.exportContainer).find(".map-toolbar-item").removeClass('active');
            $(this.exportContainer).find(".export-rectangle").addClass('active');

            this.mapControl.selectionHandler.isActive = false;
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            $('#start-export').attr('disabled', 'true');
            this._selectByRectangle();
        };
    }

    _selectByRectangle() {
        this.currentSelection = 'rectangle';
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource(),
            type: 'Circle',
            geometryFunction: createBox(),
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Polygon');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource().clear();
            $('#start-export').removeAttr('disabled');
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        this._addSnapInteraction(this.snapOpts);
    }

    _getSelectByPolygonHandler() {
        return () => {
            $(this.exportContainer).find(".map-toolbar-item").removeClass('active');
            $(this.exportContainer).find(".export-polygon").addClass('active');

            this.mapControl.selectionHandler.isActive = false;
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            $('#start-export').attr('disabled', 'true');
            this._selectByPolygon();
        };
    }

    _selectByPolygon() {
        this.currentSelection = 'polygon';
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource(),
            type: 'Polygon',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Polygon');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource().clear();
            $('#start-export').removeAttr('disabled');
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        this._addSnapInteraction(this.snapOpts);
    }

    _getSelectAllHandler() {
        return () => {
            $(this.exportContainer).find(".map-toolbar-item").removeClass('active');
            $(this.exportContainer).find(".export-all").addClass('active');

            this.mapControl.selectionHandler.isActive = true;
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            $('#start-export').removeAttr('disabled');
            this._selectAll();
        };
    }

    _selectAll() {
        this.currentSelection = 'all';
        this.mapControl.layerHandler.getLayerById(layerTypes.EXPORT)[0].getSource().clear();
        this._removeInteraction();
    }

    _isMobileDevice() {
        let supportsTouch = ('ontouchstart' in window || navigator.msMaxTouchPoints) && (window.innerWidth < 750);
        return supportsTouch;
    }

    _actionButtonClickHandler() {
        return () => {
            if (this.active) {
                this._hideToolbar();
            } else {
                $event.notify(eventTypes.USER_INTERACTION_STARTED, {}, this, this.classId);
                this._showToolbar();
            }
        };
    }

    _showToolbar() {
        $('#' + this.elementId).removeClass('selected');
        if (!this.layerAdded) {
            this._addExportLayer();
        }

        this.active = true;

        $event.notify(eventTypes.DRAW_TOOLBAR_VISIBLE, {}, this, this.classId);
        $('.toolbar-export').show();
    }

    _addExportLayer() {
        this.layerAdded = true;
        this.mapControl.addTemporaryVectorLayer({
            name: layerTypes.EXPORT,
            geometryType: geomTypes.GEOM_ALL,
            srid: this.mapControl.generalSettingsHandler.settings.ProjCode,
            geomField: 'geom',
            idField: 'id',
            visible: true,
            displayName: this.resourcesHandler.get('ExportResults'),
            ignoreStyle: true,
            addToLegend: false,
            parentId: layerTypes.INTERACTION_TOOLS,
            parentDisplayName: this.resourcesHandler.get('UserInteractionResults'),
            showLegend: false,
            declutter: false
        });
    }

    _hideToolbar() {
        $('#' + this.elementId).removeClass('selected');
        $('.toolbar-export').hide();
        this.active = false;
        this.mapControl.selectionHandler.isActive = true;
        this.mapControl.map.getViewport().style.cursor = 'inherit';
        $event.notify(eventTypes.DRAW_TOOLBAR_HIDDEN, {}, this, this.classId);
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}